<div
  class="flex flex-wrap items-center gap-x-3 gap-y-2"
  [class.w-full]="layout() === 'standalone'"
  role="group"
  aria-label="Filtro de segmento e série"
>
  <div class="flex max-w-full shrink-0 items-center gap-3">
    <liv-dropdown-select
      shape="pill"
      [options]="segmentOptions()"
      [selectedValue]="selectedSegment()?.id"
      [triggerLabel]="formattedSegmentName()"
      [expanded]="expanded()"
      ariaLabel="Filtro de segmento"
      (selectionChange)="handleSelectSegment($event)"
    />

    @if (years().length > 0) {
      <span
        class="h-4 w-0.5 shrink-0 bg-neutral-low-light"
        aria-hidden="true"
      ></span>
    }
  </div>

  @if (years().length > 0) {
    <div
      class="flex min-w-0 flex-1 basis-full flex-wrap items-center gap-2 sm:basis-auto"
    >
      @for (year of years(); track year.id) {
        <button
          type="button"
          class="flex h-10 shrink-0 cursor-pointer items-center justify-center overflow-hidden rounded-full border-2 border-brand-primary-pure bg-transparent px-4 py-2 font-roboto text-sm/tight font-medium text-ellipsis whitespace-nowrap text-brand-primary-pure transition-all duration-300 ease-in-out hover:border-brand-primary-lighter hover:bg-brand-primary-lighter hover:text-brand-primary-dark focus-visible:ring-2 focus-visible:ring-brand-primary-pure focus-visible:ring-offset-2 focus-visible:outline-none data-[selected=true]:border-brand-primary-pure data-[selected=true]:bg-brand-primary-pure data-[selected=true]:text-white data-[selected=true]:hover:border-brand-primary-pure data-[selected=true]:hover:bg-brand-primary-pure data-[selected=true]:hover:text-white"
          [attr.data-selected]="year.id === selectedGrade()?.id"
          (click)="handleSelectGrade(year)"
        >
          {{ year.nome }}
        </button>
      }
    </div>
  }
</div>
